export default __webpack_public_path__ + "static/process-6-2fe73ba7f0c7f73310bf074e83d6df2f.png";